import React from 'react';
import './ABSTimeLineBox.less';
import { ABSTag, ITagType, ITagFilledSize } from '../ABSTag';
import ABSParagraph from '../ABSParagraph';

export interface IABSTimeLineBoxProps {
  content?: any;
  title: string;
  level: number;
}

class ABSTimeLineBox extends React.Component<IABSTimeLineBoxProps> {
  render() {
    const { title, level, content } = this.props;
    const color = level > 1 ? '#009AE3' : '#494D5C';
    return (
      <div className="abs-timeline-box">
        <ABSTag content={title} color={color} visible={true} type={ITagType.filled} filledSize={ITagFilledSize.large}/>
        <pre style={{ overflow: 'hidden' }}>
          <ABSParagraph>{content}</ABSParagraph>
        </pre>
      </div>
    );
  }
}

export default ABSTimeLineBox;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ABSTimeline/ABSTimeLineBox.tsx